module.exports = __webpack_public_path__ + "static/media/white-hydropro.3d6b628e.svg";